import React from 'react';
import {
  Flex,
  Text,
  GridItem,
  SimpleGrid,
  Divider,
  Spacer,
  Textarea,
} from '@chakra-ui/react';
import styles from '../styles/mobileBannerStyles';
import theme from '../config/color';
import UncontrolledEditor from '../components/textEditor/textEditor';

import {
  customSwtich,
  customInputLabel,
  customUpdateCancelBtn,
} from '../components/createAppVersionComponent/createAppVersionComponent';
import { dropdownCustom } from '../components/bannerComponents/customBannerComponents';
import { renderCopyRight } from '../components/aboutUsComponent/customCompoent';
import {
  customTextarea,
  MiniHeader,
} from '../components/common/customComponent';
import { customSaveButton } from '../components/inboxMessagingComponent';

const CreateOauthXox = () => {
  console.log('CreateOauthXox gg bro');
  return (
    <Flex flexDirection={'column'} backgroundColor={'#FAFDFB'} height={'80vh'}>
      {MiniHeader({
        title: 'Create Oauth XOX',
        path: 'Dashboard / CMS & Backend Setup / Create Oauth XOX',
      })}

      <Flex {...styles.parentFlex}>
        <SimpleGrid width={'100%'} columns={2} spacingX={'50px'}>
          {customInputLabel({
            title: 'Name',
            mandatory: true,
          })}
          {customInputLabel({
            title: 'Hashed Name',
            mandatory: true,
          })}
        </SimpleGrid>

        <SimpleGrid
          width={'100%'}
          columns={3}
          spacingX={'50px'}
          marginTop={'4%'}
        >
          {customInputLabel({
            title: 'Client ID',
            mandatory: true,
          })}
          {customInputLabel({
            title: 'Client Secret',
            mandatory: true,
          })}{' '}
          {customInputLabel({
            title: 'Redirect',
            mandatory: true,
          })}
        </SimpleGrid>

        {customUpdateCancelBtn({
          title1: 'Submit',
          title2: 'Cancel',
        })}
      </Flex>
      <Spacer />
      <Divider orientation="horizontal" marginTop={5} marginBottom={2} />
      <Flex position={'sticky'} marginLeft={4}>
        {renderCopyRight()}
      </Flex>
    </Flex>
  );
};

export default CreateOauthXox;
